import React from 'react';
import Header from '../Header/Header';
import Form from '../Form/Form';
import About from '../About/About';
import Action from '../Action/Action';
import Footer from '../Footer/Footer';

function Home() {
  return (
    <div id="home">
      <Header />
      <Form />
      <About />
      <Action />
      <Footer />
    </div>
  );
}

export default Home;
